import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CommonService } from '@services/common.service';

declare var jQuery: any;

@Directive( { selector: '[authority]' } )
export class AuthorityDirective implements OnInit {

    @Input() authority: string | string[];

    constructor(
        private el: ElementRef,
        private commonService: CommonService ) {

        commonService.getUserChangeEmitter().subscribe( user => {
            this.checkAuthority();
        } );
    }

    ngOnInit(): void {
        this.checkAuthority();
    };
    

    checkAuthority(): void {
        if ( this.commonService.hasAuthority( this.authority ) ) {
            jQuery( this.el.nativeElement ).show();
        } else {
            jQuery( this.el.nativeElement ).hide();
        }
    }

}